import {useState} from "react";

import {useNavigateWithReload} from "base/navigation/hooks";
import {useErrors} from "base/error/provider";
import {ContactService} from "contact/service";
import {contact_view_adapter} from "contact/model";

import {ContactForm} from "contact/presentational/form";
import {AddNewInlineItemButton, AddNewInlineItemFormBox} from "base/shared/components";

const CreateContactDataContent = ({permitId}) => {
    const navigate = useNavigateWithReload();
    const {handleErrors} = useErrors();

    const [mode, setMode] = useState("button");

    const handleFormSubmit = contact => {
        ContactService.create(contact_view_adapter(contact))
            .then(createdContact => {
                setMode("button");
                navigate("", true);
            })
            .catch(error => {
                handleErrors(error);
            });
    };

    return mode === "button" ? (
        <AddNewInlineItemButton
            onClick={() => {
                setMode("create");
            }}
            label="Acrescentar contacto"
        />
    ) : mode === "create" ? (
        <AddNewInlineItemFormBox label="Acrescentar contacto">
            <ContactForm
                permitId={permitId}
                onSubmit={handleFormSubmit}
                onCancel={() => {
                    setMode("button");
                }}
            />
        </AddNewInlineItemFormBox>
    ) : null;
};

export default CreateContactDataContent;
